document.addEventListener('DOMContentLoaded', function () {

  document.addEventListener('click', function(e){

    const openBtn = e.target.closest('.modal-link');
    const closeBtn = e.target.closest('.close');
    const modalMain = document.querySelector('.modal-main');

    if(openBtn){
      e.preventDefault();

      modalMain.classList.add('active');
      document.body.style.overflow='hidden';
    }

    if(closeBtn){
      modalMain.classList.remove('active');
      document.body.style.overflow='';
    }

    if(e.target.classList.contains('modal-main')){
      modalMain.classList.remove('active');
      document.body.style.overflow='';
    }

  });

});